import React from "react";

export const Benefits = ({ data, ui }) => {
  return (
    <div id="benefits" className="text-center benefits-section">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>{ui?.title}</h2>
          {ui?.subtitle ? <p>{ui.subtitle}</p> : null}
        </div>
        <div className="row benefits-grid">
          {data
            ? data.map((benefit, index) => (
                <div
                  key={`${benefit.title}-${index}`}
                  className="col-xs-12 col-sm-6 col-md-3 benefits-item"
                >
                  <i className={benefit.icon} aria-hidden="true"></i>
                  <h3>{benefit.title}</h3>
                  {benefit.text ? <p>{benefit.text}</p> : null}
                </div>
              ))
            : ui?.loading}
        </div>
      </div>
    </div>
  );
};
